import { useContext } from 'react';
import { LoreContext } from 'contexts/lore_context';

const useLore = () => {
    return useContext(LoreContext);
};

export default useLore;
